// Central message store — all user-facing strings live here.
// Language: British English. Tone: calm, helpful, and reassuring.
export const message = {
  // ─── Success Notifications ───────────────────────────────────────────────
  FILE_UPLOAD_SUCESSFUL: "File uploaded successfully.",
  FILE_DELETE_SUCCESS: "File deleted successfully.",
  DELETE_SUCCESS: "File deleted successfully.",
  CRM_FORM_UPDATE: "Record updated successfully.",
  DELETE_CRM_RECORD: "Record deleted successfully.",
  RECORD_DELETE_SUCCESS: "Record deleted successfully.",
  EDGE_DELETE_SUCCESS: "Edge deleted successfully.",
  MEETING_DELETED: "Meeting deleted successfully.",
  MEETING_SYNCED: "Meeting synced successfully.",
  GIFT_APPROVE_SUCESSFUL: "The gift has been approved.",
  GIFT_REJECT_SUCCESS: "The gift has been declined.",
  INVOICE_APPROVE_REJECT: "The invoice has been declined.",
  INVOICE_APPROVE_SUCCESSFUL: "The invoice has been approved.",
  TRADE_APPROVE_SUCESSFUL: "The trade has been approved.",
  TRADE_REJECT_SUCCESS: "The trade has been declined.",
  MAIL_SENT_SUCCESS: "Your message has been sent.",
  SUCCESS: "Request completed successfully.",
  LETTER_DELETE_SUCCESS: "Letter deleted successfully.",
  LOAN_DRAFT_RESTORED: "Your saved draft has been restored.",
  LOAN_DRAFT_DISCARDED: "Your saved draft has been cleared.",
  LOAN_DRAFT_SAVED: "Draft saved successfully.",
  LOAN_SAVED: "Loan submitted successfully.",
  LOAN_UPDATED: "Loan updated successfully.",
  BORROWER_DRAFT_RESTORED: "Your saved borrower draft has been restored.",
  BORROWER_DRAFT_DISCARDED: "Your saved borrower draft has been cleared.",
  COMMENT_ACTION_MSG: "Action recorded. The Servicer AM will be notified.",
  syncStart: "Sync started. This may take a few minutes to complete.",
  LOAN_AMENDMENT_SAVED: "Loan amendment submitted successfully.",
  LOAN_AMENDMENT_ACTION_SUCCESS: "Action recorded successfully.",

  // ─── Drawdown / Payment Approval ────────────────────────────────────────
  DRAWDOWN_CREATED: "The outbound payment request has been created.",
  DRAWDOWN_REJECTED: "The request has been declined.",
  DRAWDOWN_APPROVED: "The request has been approved.",
  DRAWDOWN_AUTO_CANCELLED: "This request has been automatically cancelled.",
  DRAWDOWN_ALREADY_PROCESSED: "This request has already been processed.",
  DRAWDOWN_ONE_APPROVER: "Only one approver is required for this request.",
  DRAWDOWN_NOT_ELIGIBLE: "You are not eligible to review this request.",
  DRAWDOWN_UNSAVED_CHANGES:
    "You have unsaved changes. Are you sure you want to close this form? Your changes will be lost.",
  DRAWDOWN_SUPERVISOR_FIRST:
    "A supervisor must approve first for amounts of £2M or more.",
  DRAWDOWN_ADMIN_SECOND:
    "Only an Admin can approve after the Supervisor for amounts of £2M or more.",
  DRAWDOWN_SELF_APPROVAL: "You cannot approve your own request.",
  DRAWDOWN_COMMENT_REQUIRED: "A comment is required before taking action.",

  // ─── Global Search ───────────────────────────────────────────────────────
  SEARCH_PLACEHOLDER: "Search Loans, Borrowers, and Exposure Groups",
  SEARCH_ALL_TAB: "All",
  SEARCH_NO_RESULTS: "No matches found",
  SEARCH_NO_RESULTS_HINT: "Try a different name or reference.",
  SEARCH_IDLE_HINT: "Search across loans and borrowers.",
  SEARCH_QUICK_LINKS: "Go to",
  SEARCH_SEARCHING: "Searching…",
  SEARCH_ERROR: "Search is unavailable right now. Please try again.",
  SEARCH_TRIGGER_LABEL: "Search",
  SEARCH_FOOTER_NAVIGATE: "Navigate",
  SEARCH_FOOTER_OPEN: "Open",
  SEARCH_FOOTER_CLOSE: "Close",
  SEARCH_FOOTER_SWITCH: "Switch tabs",
  SEARCH_RECENT: "Recent",
  SEARCH_RECENT_CLEAR: "Clear",
  SEARCH_MIN_CHARS_HINT: "Keep typing to search…",
  SEARCH_RETRY: "Try again",

  // ─── Error Notifications ─────────────────────────────────────────────────
  SOMETHING_WENT_WRONG: "We encountered a problem. Please try again.",
  SOMETHING_WENT_WRONG_RETRY:
    "We encountered a problem. Please try again shortly.",
  CONTACT_ADMIN:
    "We encountered a problem. Please try again or contact your administrator.",
  CRM_FORM_UPDATE_ERROR:
    "We were unable to save this record. Please try again.",
  RECORD_DELETE_ERROR:
    "We were unable to delete this record. Please try again.",
  SYNC_ERROR:
    "Calendar sync failed. Please contact support for assistance.",
  ERROR: "An error occurred. Please try again.",
  NOT_AUTHORIZED: "You are not authorised to approve this.",
  UN_AUTHORISED: "You are not authorised to perform this action.",
  ESG_DD_FIRST_APPROVAL:
    "An Approver (Level 1) has not been assigned to this submission.",
  SEARCH_FAILED: "The search could not be completed. Please try again.",

  // ─── Letter Errors ───────────────────────────────────────────────────────
  LETTER_LOAD_ERROR:
    "We were unable to load the letter details. Please check your connection and try again.",
  LETTER_SAVE_ERROR:
    "We were unable to save your progress. Please try again.",
  LETTER_REGENERATE_ERROR:
    "We were unable to regenerate the document. Please try again shortly.",
  LETTER_DELETE_ERROR:
    "We were unable to delete the letter. Please try again.",
  AUDIT_LOG_ERROR:
    "We were unable to load the audit log. Please try again.",
  LIST_LOAD_ERROR:
    "We were unable to load the letters list. Please try again.",

  // ─── Form & Configuration Errors ─────────────────────────────────────────
  CUSTOM_FORM_CONFIGURE_ERROR:
    "The form configuration is incorrect. Please check your settings.",
  LOAD_CONFIGURATION_ERROR:
    "We were unable to load the form configuration. Please try again.",

  // ─── Empty States ────────────────────────────────────────────────────────
  NO_CONTENT: "No records are currently available.",
  NO_CONTENT_AVAILABLE: "No content is currently available.",
  NO_DATA: "No data is currently available.",
  NO_DATA_AVAILABLE: "No data is currently available.",
  NO_DATA_FOUND: "No records are currently available.",
  NO_EDGE_FOUND: "No edge data was found.",
  NO_IMAGE_FOUND: "No image is currently available.",
  NO_MEETING_FOUND: "No meetings are currently scheduled.",
  NO_SEARCH_FOUND: "No matching results were found.",
  DATA_NOT_FOUND: "No trail data was found.",
  AUDIT_LOG_EMPTY: "No audit log entries are available for this letter.",
  NO_POSTCODE_RESULTS:
    "No existing applications were found for this postcode.",

  // ─── Field Validation ────────────────────────────────────────────────────
  REQUIRED: "Required",
  REQUIRED_FIELD: "Please complete all required fields (marked with *).",
  FIELD_REQUIRED: "This field is required.",
  VALID_VALUE: "Please enter a valid value.",
  DUPLICATE_RECORD_FOUND: "A duplicate record already exists.",
  ENTER_WHOLE_NUMBER: "Please enter a whole number.",
  ENTER_VALID_NUMBER: "Please enter a valid number.",
  ENTER_PERCENTAGE_RANGE: "Please enter a percentage between 0 and 100.",
  VALUE_MIN_ONE: "The value must be 1 or greater.",
  VALUE_MIN_ZERO: "The value cannot be negative.",
  CURRENCY_CODE_FORMAT:
    "Please use a 3-letter ISO currency code (e.g. GBP, USD, EUR).",
  DATA_VALIDATION: "Data Validation:",

  // ─── Confirmation Dialogs ────────────────────────────────────────────────
  ARE_YOU_SURE:
    "Are you sure you want to close? Your unsaved changes will be lost.",
  DELETE_ROW: "Are you sure you want to remove this item?",
  DELETE_TAB_WARNING: "Are you sure you want to delete this tab?",
  DELETE_WARNING: "Are you sure you want to delete this?",
  LOSE_PROGRESS:
    "Are you sure you want to close this form? Any unsaved progress will be lost.",
  LOAN_DRAFT_SAVED_ON_CLOSE:
    "You have unsaved changes. Would you like to save them as a draft before closing?",

  // ─── Informational / Guidance ────────────────────────────────────────────
  PLEASE_WAIT: "Please wait...",
  SUPPORT_TEAM: "Please contact the support team.",
  FILTER_SELECTION: "Please select at least one filter to continue.",
  SELECT_ACCOUNT: "Please select an account to continue.",
  SELECT_TAB_MESSAGE: "Please select at least one tab to download.",
  REPORT_NAME_ERROR:
    "A report with this name already exists. Please choose a different name.",
  LOAN_DRAFT_EMPTY_WARNING: "Please add some data before saving a draft.",
  BORROWER_DRAFT_EMPTY_WARNING:
    "Please add some data before saving a draft.",
  FILE_FORMAT_NOT_SUPPORTED: "This file format is not supported.",
  MAXIMUM_LIMIT_REACHED: "The maximum number of items has been reached.",
  MULTIPLE_FILES_NOT_ALLOWED: "Only one file can be uploaded at a time.",

  // ─── Documents Dashboard ─────────────────────────────────────────────────
  DOC_CATEGORY_ADDED: "Category created successfully.",
  DOC_CATEGORY_ADD_ERROR:
    "We were unable to create the category. Please try again.",
  DOC_UPLOADED: "Document uploaded successfully.",
  DOC_UPLOAD_ERROR:
    "We were unable to upload the document. Please try again.",
  DOC_DELETED: "Document moved to Bin.",
  DOC_DELETE_ERROR:
    "We were unable to delete the document. Please try again.",
  DOC_CATEGORY_REQUIRED: "Please select a category before uploading.",
  DOC_FILE_REQUIRED: "Please select at least one file to upload.",
  NO_SALE_DATA: "No sales tracker data found.",
  NO_PAYMENT_DETAILS: "No payment details found.",
  NO_MATCHING_TEMPLATES: "No matching templates found.",
  NO_LOAN_ADVANCES: "No loan advances data found.",
  NO_MATCHING_LETTERS: "No matching letters found.",
  SELECT_LETTER_TEMPLATE: "Please select a letter template to view generated letters.",
  NO_DIRECT_DEBIT_RECORDS: "No direct debit records found.",
  NO_CARS_DATA: "No CARS data found.",
  NO_ANNUAL_REVIEW_QUESTIONS: "No annual review questions found.",
  NO_PIPELINE_DATA: "No pipeline data found.",
  CROSS_COLLATERALISATION_CHECK_FAILED:
    "Cross collateralisation check failed. The loan cannot be closed.",
  NO_PIPELINE_STAGES_FOUND: "No pipeline stages found.",
  NO_TASKS_FOUND: "We are sorry, no tasks found.",
  NO_TEAM_MEMBERS_ASSIGNED: "No team members assigned.",
  NO_LOAN_AMENDMENT: "No loan amendment is available.",
  LOAN_AMENDMENT_COMMENT_REQUIRED: "A comment is required before taking action.",
};

export const errorCode = {
  200: message.SUCCESS,
  401: message.UN_AUTHORISED,
  500: message.CONTACT_ADMIN,
};
